import React, { createContext, useContext, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { ChevronDown, ChevronRight } from "lucide-react";

export const BarCtx = createContext(null);

export function BarTitle({ children }) {
  const ctx = useContext(BarCtx);
  if (!ctx || !ctx.els.title) return children;
  return createPortal(<div className="mw-bartitle flex min-w-0 items-center gap-2">{children}</div>, ctx.els.title);
}

export default function CollapseBar({ id, label, children, className = "", block = false }) {
  const ctx = useContext(BarCtx);
  const [localOpen, setLocalOpen] = useState(false);
  const docked = !!(ctx && ctx.els.toggles);
  const open = docked ? ctx.openId === id : localOpen;
  useEffect(() => { if (ctx?.reg && /actions/.test(id)) { ctx.reg(id, true); return () => ctx.reg(id, false); } }, [id]); // eslint-disable-line react-hooks/exhaustive-deps
  const toggle = () => (docked ? ctx.setOpenId(open ? null : id) : setLocalOpen((o) => !o));
  const btn = (
    <button data-testid={`cb-toggle-${id}`} onClick={toggle} title={open ? "KAPAT" : "AÇ"}
      className={`inline-flex h-8 shrink-0 items-center gap-1 rounded-md border px-2 text-xs font-semibold ${open ? "border-blue-500/50 bg-blue-500/15 text-blue-300" : "border-slate-700 bg-slate-800 text-slate-300 hover:bg-slate-700"}`}>
      {open ? <ChevronDown className="h-3.5 w-3.5" /> : <ChevronRight className="h-3.5 w-3.5" />}{label}
    </button>
  );
  const body = block
    ? <div data-testid={`cb-body-${id}`} className="w-full">{children}</div>
    : <div data-testid={`cb-body-${id}`} className="flex min-w-0 flex-1 flex-nowrap items-center gap-2 [&>*]:shrink-0">{children}</div>;
  if (docked) return <>{createPortal(btn, ctx.els.toggles)}{open && ctx.els.panel && createPortal(body, ctx.els.panel)}</>;
  return (
    <div data-testid={`cb-${id}`} className={`flex min-w-0 items-center gap-2 ${className}`}>
      {btn}
      {open && <div className="min-w-0 flex-1 overflow-x-auto">{body}</div>}
    </div>
  );
}
